import { isEmpty, isString } from 'lodash';

export const extractPath = (url: string | null | undefined): string => {
  if (isString(url) && !isEmpty(url)) {
    return new URL(url).pathname.slice(1);
  }

  return '';
};
